import SockJS from "sockjs-client";
import { Client } from "@stomp/stompjs";
import { BASE_URL } from "../configs/apiConfig";

export const connectWebSocket = (
  stationId: number,
  onAccessGranted: (update: any) => void
) => {
  const socket = new SockJS(`${BASE_URL}/ws`);
  const stompClient = new Client({
    webSocketFactory: () => socket,
    reconnectDelay: 5000,
    onConnect: () => {
      console.log("WebSocket connected");
      console.log("Subscribed to", `/topic/station-access/${stationId}`);
      stompClient.subscribe(`/topic/station-access/${stationId}`, (message) => {
        const update = JSON.parse(message.body);
        if (update.status === "GRANTED") {
          onAccessGranted(update);
        }
        console.log("Received update:", update);
      });
    },
    onStompError: (frame) => {
      console.error("STOMP error:", frame.headers["message"]);
    },
    onWebSocketError: (err) => {
      console.error("WebSocket error:", err);
    },
  });

  stompClient.activate();
  return stompClient;
};
